import { CardContent, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/Table";
import { useEffect, useState } from "react";
import { FileUpload, FilterAlt } from "@mui/icons-material";
import { fetchData, postData } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";
import BulkUpload from "../../../components/blukUplod";
import InsurerCategoryFilterDialog from './components/InsurerCategoryFilterDialog.js';

const InsurerCategoryList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();
  const [isRefresh, setIsRefresh] = useState(false);
  const currentPage = useSelector(
    (state) => state?.insurerCategoryStore?.currentPage
  );
  const rowsPerPage = useSelector(
    (state) => state?.insurerCategoryStore?.rowsPerPage
  );
  const totalPages = useSelector(
    (state) => state?.insurerCategoryStore?.totalPages
  );
  const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
  const [insurerCategoryData, setInsurerCategoryData] = useState([]);
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [filterData, setFilterData] = useState({
      isActive: "",
      gInsurerId: ""
  });

  useEffect(() => {
    fetchCategoryList();
  }, [isRefresh, currentPage, rowsPerPage, search]);

  //List API
  const fetchCategoryList = async () => {
    setCircleLoading(true);
    try {
      let url = `/reference/insurer/key-value-category?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
                                          
      //filter
      if(filterData.isActive !== "") {
          url += `&isActive=${filterData.isActive}`;
      }
      if(filterData.gInsurerId !== "") {
          url += `&gInsurerId=${filterData.gInsurerId}`;
      }
      const response = await fetchData(url);

      if (response?.success) {
        setInsurerCategoryData(response?.data?.items);
        dispatch(setTotalPages(response?.data?.totalPages));
      }
    } catch (error) {
      showSnackbar(error?.response?.data?.message, "error");
    } finally {
      setCircleLoading(false);
    }
  };

  const handleDelete = async (row) => {
    setCircleLoading(true);
    try {
      const response = await postData(`/reference/insurer/key-value-category`, {
        ids: [row?.id],
      });
      const responseMessage = response?.message;
      setIsRefresh(!isRefresh);
      if (response?.success) {
        showSnackbar(responseMessage, "success");
      } else {
        showSnackbar(responseMessage, "error");
      }
    } catch (error) {
      showSnackbar(error?.response?.data?.message, "error");
    } finally {
      setCircleLoading(false);
    }
  };

  //Table Mapping
  const insurerCategoryListTable = {
    columns: [
      {
        key: "sno",
        label: "S.No.",
        renderCell: (row) => row.sno,
      },
      {
        key: "categoryName",
        label: "Category Name",
        renderCell: (row) => row.categoryName,
      },
      {
        key: "code",
        label: "Code",
        renderCell: (row) => row.code,
      },
      {
        key: "gInsurerName",
        label: "Insurer",
        renderCell: (row) => row.gInsurerName
      },
      {
        key: "createdAt",
        label: "Created At",
        renderCell: (row) => row.createdAt,
      },
      {
        key: "isActive",
        label: "Status",
        renderCell: (row) => (
          <span>
            {row.isActive ? (
              <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
            ) : (
              <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
            )}
          </span>
        ),
      },
    ],
    rows: insurerCategoryData?.map((category, index) => ({
      id: category?.id,
      sno: index + 1,
      categoryName: category?.categoryName || "",
      code: category?.code || "",
      isActive: category?.isActive,
      gInsurerName: category?.gInsurerName,
      createdAt: new Date(category?.createdAt).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
    })),
  };

  const handleAddNewCategory = () => {
    navigate(`/insurer-master/insurer-category/add-category`);
  };

  const actions = {
    edit: true,
    view: true,
    delete: true,

    onEdit: (row) => {
      navigate(
        `/insurer-master/insurer-category/add-category?pageType=edit&id=${row.id}`
      );
    },
    onView: (row) => {
      navigate(
        `/insurer-master/insurer-category/add-category?pageType=view&id=${row.id}`
      );
    },
    onDelete: (row) => handleDelete(row),
  };

  const handlePaginationChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    dispatch(setRowsPerPage(rowsPerPage));
    dispatch(setCurrentPage(1));
  };

  const handleSearch = (value) => {
      setSearch(value);
  };

  return (
    <DashboardLayout>
      <CardHeader
        title={
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Insurer Key Value Category List
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                List of Key Value Categories linked to Insurers.
              </MaterialTypography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <MaterialButton
              variant="gradient"
              color="dark"
              size="small"
              startIcon={<FilterAlt/>}
              onClick={(event) => setAnchorEl(event.currentTarget)}
              >
              Filter
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FileUpload />}
                onClick={() => setOpenUploadFileDialog(true)}
              >
                Bulk Upload
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddNewCategory()}
              >
                Category
              </MaterialButton>
            </Stack>
          </Stack>
        }
      />
      <CardContent>
        <Table
          columns={insurerCategoryListTable?.columns}
          data={insurerCategoryListTable?.rows}
          actions={actions}
          pagination={{
            totalPages,
            currentPage,
            onPageChange: (page) => handlePaginationChange(page),
            rowsPerPage,
            onRowsPerPageChange: (rowsPerPage) =>
              handleRowsPerPageChange(rowsPerPage),
            rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Insurer Category found"
          handleSearch={handleSearch}
        />
        <BulkUpload
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        endPoint="/reference/motor/insurer/bulkUpload/insurer-PreviousInsurer"
        fetchList={fetchCategoryList}
      />
      </CardContent>
      <InsurerCategoryFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchCategoryList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  );
};

export default InsurerCategoryList;